import { clsx } from 'clsx';
import { FC, PropsWithChildren } from 'react';

import style from './Layout.css';

export interface ILayoutProps {
  filled?: boolean;
  fullwidth?: boolean;
  dataMark?: string;
  tag?: 'div' | 'section';
  adaptiveStyles?: boolean;
  // Anchor for Sticky Header scrolling
  id?: string;
  // Data-attribute that contains anchor and tab name
  'data-nav-tab'?: string;
}

export const Layout: FC<PropsWithChildren<ILayoutProps>> = props => {
  /* istanbul ignore next */
  const {
    filled = true,
    fullwidth = false,
    tag: Tag = 'section',
    dataMark = 'Layout',
    id,
    adaptiveStyles,
    children,
  } = props;

  /* istanbul ignore next */
  const fullWidthStyles = fullwidth ? style['layout--fullwidth'] : style['layout'];

  return (
    <Tag
      className={clsx(fullWidthStyles, {
        [style['layout--filled']]: filled,
        [style['layout-mobile']]: adaptiveStyles,
      })}
      data-mark={dataMark}
      data-nav-tab={props['data-nav-tab']}
      id={id}
    >
      {children}
    </Tag>
  );
};

Layout.displayName = 'Layout';
